module.exports = __webpack_public_path__ + "static/media/8.7e401a7a.jpg";